import React, { Component } from 'react';
import propTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';

import ComponentsToolbox from 'app/ComponentsToolbox/components/ComponentsToolbox';
import { noop } from 'lib/noop';
import { PrimaryButton } from 'ui/Components';

/**
 * This is a redux connected component. This component renders a button.
 * Clicking the button startes a wizard to choose the type of new component.
 * Eventually the new component is added to existing page or container component.
 * @param {object} props - the props passed to this component
 * @returns {React.Component} the add new component component
 */
export default class AddNewComponent extends Component {
  static propTypes = {
    buttonText: propTypes.string,
    className: propTypes.string,
    componentsList: propTypes.arrayOf(propTypes.string),
    'data-test-id': propTypes.string,
    isReadonly: propTypes.bool,
    newComponentSelected: propTypes.func,
    pageComponents: propTypes.arrayOf(propTypes.number),
    pageTemplateName: propTypes.string,
    pageType: propTypes.string,
    renderingEnvName: propTypes.string
  };

  static defaultProps = {
    buttonText: 'Add New Component',
    className: '',
    componentsList: [],
    'data-test-id': 'addNewComponent-button',
    isReadonly: true,
    newComponentSelected: noop,
    pageComponents: [],
    pageTemplateName: '',
    pageType: '',
    renderingEnvName: ''
  };

  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false
    };
    this.componentSelected = this.componentSelected.bind(this);
    this.modalToggle = this.modalToggle.bind(this);
    this.onAddClick = this.onAddClick.bind(this);
    this.onSelected = this.onSelected.bind(this);
  }

  /**
   * toggles component template modal and set selected component
   * @param {string} componentVariation - component variation of the selected component
   */
  onSelected(componentVariation) {
    this.modalToggle();
    this.componentSelected(componentVariation);
  }

  /**
   * if only one type on component is allowd then selects that by default
   * else shows toolbox to select the component from the list
   */
  onAddClick() {
    const { componentsList } = this.props;
    if (componentsList.length === 1) {
      this.componentSelected(componentsList[0]);
    } else {
      this.modalToggle();
    }
  }

  /**
   * calls the call back function after component selection
   * @param {string} componentVariation - component variation of the selected component
   */
  componentSelected(componentVariation) {
    const { newComponentSelected, pageType, pageTemplateName } = this.props;
    const renderingEnv = {
      pageTemplateName,
      pageType
    };
    newComponentSelected({
      componentVariation,
      renderingEnv
    });
  }

  /**
   * toggle the rendering environment modal state between open and close
   */
  modalToggle() {
    this.setState(ps => ({ isModalOpen: !ps.isModalOpen }));
  }

  render() {
    const {
      onAddClick,
      modalToggle,
      onSelected,
      props: {
        buttonText,
        className,
        componentsList,
        'data-test-id': testId,
        isReadonly,
        renderingEnvName,
        pageComponents
      },
      state: { isModalOpen }
    } = this;

    return (
      <React.Fragment>
        <PrimaryButton
          className={className}
          data-test-id={testId}
          disabled={isReadonly}
          onClick={onAddClick}
        >
          {buttonText}
        </PrimaryButton>
        <Modal isOpen={isModalOpen} toggle={modalToggle}>
          <ModalBody>
            <ComponentsToolbox
              componentsList={componentsList}
              onCancel={modalToggle}
              onSelect={onSelected}
              renderingEnvName={renderingEnvName}
              pageComponents={pageComponents}
            />
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}
